import { useNewCode } from '@calendly/feature-check-react'
import { object } from '@calendly/form/validation'
import { useSelector } from 'react-redux'

import { getPaymentsValidationSchema, BILLING_FEATURE_KEY, preparePaymentsValuesForPreview } from 'components/event_type_edit'
import { isRestrictedFeatureSelector } from 'features/billing'

import {
  PAYPAL_PPCP_FEATURE_CODE,
  resolvePaymentProviderForServer,
} from './payment_provider_utils'

export const getInitialValues = (eventType) => {
  const paymentMethod = eventType.payment_method || {}
  const amountCents = Number(paymentMethod.amount_cents || 0)
  const rawProvider = (paymentMethod.enabled && paymentMethod.provider) || 'none'

  return {
    paymentId: paymentMethod.id,
    provider: rawProvider,
    currency: paymentMethod.currency || 'USD',
    amount: amountCents / 100,
    paymentTerms: paymentMethod.payment_terms || ''
  }
}

export const usePrepareValuesForPreview = () => {
  const isUpgradeRequired = useSelector((state) => isRestrictedFeatureSelector(state, { featureKey: BILLING_FEATURE_KEY }))
  const isPaypalPpcpFeatureEnabled = useNewCode(PAYPAL_PPCP_FEATURE_CODE, false)?.enabled

  return (eventType, formValues) => (
    preparePaymentsValuesForPreview(eventType, formValues, isUpgradeRequired, isPaypalPpcpFeatureEnabled)
  )
}

export const getFormatValuesToServerData = (eventType) => (values) => {
  const { paymentId, provider, amount, currency, paymentTerms } = values

  const serverProvider = resolvePaymentProviderForServer(provider, eventType)

  return {
    payment_method_attributes: {
      id: paymentId,
      provider: serverProvider,
      amount: provider === 'none' && !amount ? null : amount,
      currency,
      payment_terms: paymentTerms,
      enabled: provider !== 'none',
    }
  }
}

export const getValidationSchema = () => object({})
  .concat(getPaymentsValidationSchema())
